import { ConsolidatedCompSources } from '@/endpoints/itasca/comps/queryConsolidatedComps';
import { CompSourcesEnumsBE } from '@/models/features/comp';

import { SoldLandType } from '../comp-filter';

/**
 * @Note make sure this style is set in the tailwind config
 * @param soldLandType CompSources
 * @returns background inline style
 */
function getDotColor(
  soldLandType:
    | CompSourcesEnumsBE
    | SoldLandType
    | ConsolidatedCompSources
    | 'acretrader'
    | 'courthouse'
    | 'auction'
    | 'sale'
) {
  switch (soldLandType) {
    case 'contributed': {
      return 'bg-sold-land-contributory';
    }
    case 'curated': {
      return 'bg-sold-land-curated';
    }
    case 'courthouse': {
      return 'bg-sold-land-courthouse';
    }
    case 'confidential': {
      return 'bg-sold-land-private';
    }
    default:
      return '';
  }
}

export default getDotColor;
